import { useEffect } from "react"

const FreestarScript = () => {
  useEffect(() => {
    window.freestar = window.freestar || {}
    window.freestar.queue = window.freestar.queue || []
    if (window.location.pathname === "/") {
      window.freestar.queue.push(function () {
        window.freestar.disableRefresh()
      })
    }

    const isLocal = typeof window !== "undefined" && window.location.hostname === "localhost"

    if (isLocal && window.googletag && window.googletag.pubads) {
      window.freestar.queue.push(function () {
        window.googletag.pubads().set("page_url", "https://mindbodygreen.com")
      })
    }
  }, [])

  return null
}

export default FreestarScript
